import { parseMinerName } from "./parseMinerName";

interface IMinerLocation {
  location: string;
  object: string;
  rack_id: string;
  letter: string;
  x: number;
  y: number;
}

export const minerNameToLocation = (name: string): IMinerLocation => {
  const splited = name.split("-");

  const { letter, YX, rack } = parseMinerName(
    splited.length > 3 ? `${splited[2]}-${splited[3]}` : splited[2]
  );
  const [Y, X] = YX;

  return {
    location: splited[0],
    object: splited[1],
    rack_id: rack,
    letter,
    x: X,
    y: Y,
  };
};
